import firstBonusImg from "../../assets/img/bonus-1.png";
import firstBonusImgWebp from "../../assets/img/bonus-1.webp";
import secondBonusImg from "../../assets/img/bonus-2.png";
import secondBonusImgWebp from "../../assets/img/bonus-2.webp";

const Gifts = () => {

    return (
        <section id="gifts">
            <div className="container-fluid">
                <div className="row justify-content-center align-content-center py-4">
                    <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius text-white text-center">
                        <div className="row justify-content-center align-items-center">
                            <div className="text-center">
                                <h1 className="mb-0">Improve your life with</h1>
                                <h1>Dr. Hart's Wisdom</h1>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center my-3">
                            <div className="col-md-6 text-center">
                                <p className="fs-5 gg-yellow mb-0"><span className="fw-bold">Free bonuses</span> when you order 3 or 6 bottles</p>
                                <p className="fs-5"><span className="text-uppercase fw-bold">Instant download</span> of Digital Files</p>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center mb-5">
                            <div className="col-md-4 col-12 text-center">
                                <picture>
                                    <source srcSet={firstBonusImgWebp} type="image/webp" />
                                    <img className="img-fluid rounded gg-img-gift" alt="Dr. Hart" src={firstBonusImg} loading="lazy" />
                                </picture>
                            </div>
                            <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                                <h3>1. Dr. Hart's Blood Sugar <span className="gg-yellow">Cheat Sheet</span> [FREE]</h3>
                                <p>Your no-nonsense advice to real-life blood sugar control. It’s the roadmap Dr. Hart gives exclusively to his own patients. But now, it can be yours.</p>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-4 col-12 text-center">
                                <picture>
                                    <source srcSet={secondBonusImgWebp} type="image/webp" />
                                    <img className="img-fluid rounded gg-img-gift" alt="Dr. Hart" src={secondBonusImg} loading="lazy" />
                                </picture>
                            </div>
                            <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                                <h3>2. Dr. Hart’s Metabolic Reset <span className="gg-yellow">Protocol</span> [FREE]</h3>
                                <p>A 30-day guide to help boost your metabolism, naturally support blood sugar, and rebuild trust in your body. Without dieting, calorie counting, or carb-cutting.</p>
                            </div>
                        </div>
                        <a href="#countdown" className="mt-5 text-decoration-none btn gg-button-buy-yellow gg-bigger-button fw-bold text-uppercase gtm-nav-btn" data-gtm-label="GlucoGen - Gifts Section - Yours in Seconds Button - Go to Buy">Yours in seconds</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gifts;